import instance from 'api/instance';
import { ICreatePracticeExam, ICreateTheoryExam } from './types';

export const createTheoryExam: ICreateTheoryExam = (data) =>
  instance.post('/exams/theory', data);

export const createPracticeExam: ICreatePracticeExam = (data) =>
  instance.post('/exams/practice', data);
